import { selector } from "recoil";
import { statusListAtom } from "../atoms/statusListAtoms";

export const statusListSelector = selector({
  key: "statusListSelector",
  get: ({ get }) => {
    const data = get(statusListAtom);
    return data.statusList;
  },
});
